import { useCallback, useMemo, useState, type ReactNode } from 'react'

import type { UserRole } from '@/types/api'

import {
  DevRolePreviewContext,
  type DevRolePreviewContextValue,
} from '@/lib/auth/devRolePreviewContext'

/**
 * Simulador de papel — somente DEV, estado em memória (não persiste em localStorage).
 */
export function DevRolePreviewProvider({ children }: { children: ReactNode }) {
  const [previewRole, setPreviewRoleState] = useState<UserRole | null>(null)

  const setPreviewRole = useCallback((role: UserRole | null) => {
    setPreviewRoleState(role)
  }, [])

  const clearPreview = useCallback(() => {
    setPreviewRoleState(null)
  }, [])

  const value = useMemo<DevRolePreviewContextValue>(
    () => ({
      previewRole,
      setPreviewRole,
      clearPreview,
      isPreviewActive: previewRole !== null,
    }),
    [previewRole, setPreviewRole, clearPreview],
  )

  if (!import.meta.env.DEV) {
    return <>{children}</>
  }

  return (
    <DevRolePreviewContext.Provider value={value}>
      {children}
    </DevRolePreviewContext.Provider>
  )
}
